import { render, staticRenderFns } from "./Sys.vue?vue&type=template&id=7da6710d&scoped=true&"
import script from "./Sys.vue?vue&type=script&lang=js&"
export * from "./Sys.vue?vue&type=script&lang=js&"
import style0 from "./Sys.vue?vue&type=style&index=0&id=7da6710d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da6710d",
  null
  
)

export default component.exports